<template>
    <WizardShell :mission="mission">
        <div class="row d-flex justify-content-center">
            <div class="col-12 col-md-8">
                <MembersEditor :mission="mission" @refresh="$emit('refresh')" />
            </div>
        </div>
        <div class="row pt-1 mb-5 d-flex justify-content-end">
            <div class="col-auto">
                <ButtonDisplay @click="$emit('next')" :type="'start'" text="Suivant" :disabled="!hasMembers" />
            </div>
        </div>
    </WizardShell>
</template>

<script>
import WizardShell from './WizardShell.vue'
import MembersEditor from '@/views/Missions/Components/Members/MembersEditor.vue'
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'

export default {
    name: 'WizardDrivers',
    props: ['mission'],
    components: { WizardShell, MembersEditor, ButtonDisplay },
    computed: {
        hasMembers() {
            return Array.isArray(this.mission?.members) && this.mission.members.length > 0;
        }
    }
}
</script>